import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material';

import { GlobalContext } from '../../contexts/global.context';

import './header.styles.scss';

export default function Header() {
  const theme = useTheme();
  let navigate = useNavigate();
  const { handleUpdate } = useContext(GlobalContext);

  // function clearCache() {
  //   localStorage.clear();
  //   window.location.reload();
  // }

  function goToHome() {
    navigate('/');
    handleUpdate('nav', { newTab: 'Home', newSubTab: 'none' });
  }
  
  return (
    <header style={{ '--primary-color': theme.palette.primary.main, '--secondary-color': theme.palette.secondary.main }}>
      <button onClick={goToHome} className='title-btn'>
        <h1>Climate Indicators for Forestry</h1>
      </button>
      <div className='angled angle-1'></div>
      <div className='angled angle-2'></div>

      {/* <button className='clear-cache-btn' onClick={clearCache}>Clear Cache (For development only)</button> */}
    </header>
  );
}